import React from "react";
import ReactTooltip from 'react-tooltip';

export interface HelpForTextProps {
    id: string
    message: string | JSX.Element
}

export const HelpForText: React.FC<HelpForTextProps> = (props: HelpForTextProps) => {
    return <>
        <a className="far fa-question-circle" data-for={props.id} data-tip onClick={e => { e.stopPropagation(); e.preventDefault(); }}></a>
        <ReactTooltip className='aus-tooltip' delayHide={500} effect='solid' getContent={tip => props.message} id={props.id} globalEventOff='click' />
    </>
}